import * as React from 'react'
import { InputBase, IconButton, Icon } from '@material-ui/core'
import { useTranslation } from 'i18n'

const Component = ({ onSearch, value, fullWidth = false }) => {
  const { t } = useTranslation('components')
  const [word, setWord] = React.useState(value)

  return (
    <div
      style={{
        backgroundColor: '#ECEFF1',
        display: 'inline-flex',
        borderRadius: 20,
        padding: '0 10px 0 20px',
        width: fullWidth ? '100%' : null,
      }}
    >
      <InputBase
        placeholder={t('Input.SearchBox.searchByArtistName')}
        inputProps={{ 'aria-label': 'Search' }}
        onChange={e => setWord(e.currentTarget.value)}
        value={word || ''}
        fullWidth={fullWidth}
        onKeyPress={e => {
          if (e.key === 'Enter') onSearch(word)
        }}
      />
      <IconButton size="small" onClick={() => onSearch(word)}>
        <Icon>search</Icon>
      </IconButton>
    </div>
  )
}

export default Component
